var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "weather" }, [
    _vm.data
      ? _c("div", [
          _c("strong", [_vm._v("Weather: ")]),
          _vm._v(
            _vm._s(_vm.data.main.temp) +
              "℉, " +
              _vm._s(_vm.data.weather[0].main)
          )
        ])
      : _c("div", [_vm._v("No data available")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b701e7a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b701e7a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/weather.vue
// module id = 348
// module chunks = 0